import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { CommonResponse } from "../interfaces/home";

@Injectable({
  providedIn: "root",
})
export class ApprovalLimitService {
  constructor(private http: HttpClient) {}
  baseUrl = environment.baseUrl + "ApprovalLimit/";
  // fetch all ApprovalLimit in the database
  allApprovalLimitData(): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(this.baseUrl);
  }
  getApprovalLimit(id: any): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(this.baseUrl + id);
  }
  getApprovalLimitByName(name: any): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(this.baseUrl + "name/" + name);
  }
  postApprovalLimit(data: any) {
    return this.http.post(this.baseUrl, data);
  }
  deleteApprovalLimit(id: any) {
    return this.http.delete(this.baseUrl + id);
  }
  updateApprovalLimit(id: any, data: any) {
    return this.http.put(this.baseUrl + id, data);
  }
  DeleteApprovalLimitModule(id: any) {
    return this.http.delete(this.baseUrl + "DeleteApprovalLimitModule/" + id);
  }
}
